import { useNavigationStore } from '~/store/navigation'
import { createFullUrl } from '@/composables/util'
import type { NavigationHookAfter } from 'vue-router'

export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter()
  const navigationStore = useNavigationStore()
  const config = useRuntimeConfig()

  router.afterEach(<NavigationHookAfter>((to, from, failure) => {
    if (failure) {
      return
    }

    const fullFromUrl = createFullUrl(from, config)
    const fullToUrl = createFullUrl(to, config)
    navigationStore.setReferrer(fullFromUrl, fullToUrl)
    navigationStore.setRoute(to)
  }))
})
